import { useMutation } from 'react-query'
import { api } from '../../../api'
import { type RequestPersistence } from '../../../../types/persistence/request-persistence'

const editRequest = async (id: number, data: RequestPersistence) => {
  const response = await api.put(`/requests/${id}`, data)
  return response.data
}

export const useRequestEditMutation = () => {
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: RequestPersistence }) {
      return editRequest(id, data)
    }
  })
}
